import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
  Sentry.init({
  dsn: environment.sentryDsn,
  release: environment.appVersion,
  denyUrls: [
    /localhost/,],
  
  // Performance Monitoring
  // tracesSampleRate: 0.1,
  // tracesSampleRate: 1,
  tracesSampleRate: 0.0,  // ✅ disables performance monitoring
  replaysSessionSampleRate: 0.0,     // ✅ disables session replay
  replaysOnErrorSampleRate: 0.0,


  environment: environment.apiUrl.split('//')[1].split('/')[0], // Use the API URL as the environment name
  

  // TODO: filter errors if needed
  beforeSend(event, hint) {
    const error = hint.originalException;
    console.log('Sentry beforeSend event:', event, 'error:', error);
    if (error && error['name'] == 'AuthorizationRequiredError') {
    return null;
    }
    else return event;

  }
});
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
